import { render, staticRenderFns } from "./Core.vue?vue&type=template&id=1c7af4d9&"
import script from "./Core.vue?vue&type=script&lang=js&"
export * from "./Core.vue?vue&type=script&lang=js&"
import style0 from "./Core.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports